import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EmployeeRoutingModule } from './employee-routing.module';
import { EmployeeProfileFormComponent } from './employee-profile-form/employee-profile-form.component';
import { AcademicFormModule } from 'src/app/modules/academic-form/academic-form.module';

@NgModule({
  declarations: [EmployeeProfileFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgxSpinnerModule,
    EmployeeRoutingModule,
    AcademicFormModule,
  ],
  exports: [EmployeeProfileFormComponent],
})
export class EmployeeModule {}
